import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromUserSelectors from '../../store/selectors/user.selectors';

@Injectable({
  providedIn: 'root'
})
export class RegisteredGuard {
  private store = inject(Store);
  private router = inject(Router);

  isRegistered = false;
  constructor() {
    this.store.pipe(select(fromUserSelectors.selectLoaded)).subscribe((loaded) => {
      this.isRegistered = loaded;
    });
  }
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isRegistered ? true : this.router.createUrlTree(['onboarding', 'terms']);
  }
}
